import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const VipPointsHistoryStyle = {
  wrapper: css`
    position: relative;
    width: 100%;
  `,
  title: css`
    font-size: 22px;
    font-weight: 600;
    margin-top: 40px;
  `,
  table: css`
    position: relative;
    width: 100%;
    margin-top: 20px;
    border-radius: 10px;
    background: ${theme.colors.primary[650]};
    overflow: hidden;
    border-collapse: collapse;

    ${media.lg} {
      display: none;
    }

    thead {
      background-color: #363861;
      display: table;
      width: 100%;
      table-layout: fixed;

      th {
        padding: 10px;
      }
    }

    tbody {
      display: block;
      max-height: 450px;
      overflow-y: auto;
      width: 100%;
      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #1d2841;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background: #363861;
        border-radius: 4px;
      }
    }

    tr {
      display: table;
      table-layout: fixed;
      width: 100%;
    }

    tr:nth-of-type(even) {
      background-color: #2a3347;
    }

    td {
      text-align: center;
      padding: 10px;
      font-size: 14px;
    }
  `,
  cardHistory: css`
    width: 100%;
    position: relative;
    display: none;
    background: ${theme.colors.primary[650]};
    border-radius: 20px;
    padding: 15px 10px;
    margin-top: 20px;
    overflow-y: auto;
    max-height: 700px;

    ${media.lg} {
      display: block;
    }

    .no-data,
    .loading-box {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 150px;
      border-radius: 10px;
      background: #0d1023;
    }

    .card {
      display: flex;
      flex-direction: column;
      padding: 15px 10px;
      border-radius: 10px;
      background: #0d1023;
      margin-bottom: 10px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .card-label {
      display: inline;
      color: #8a8a8a;
      font-size: 12px;
    }

    .card-value {
      display: inline;
      color: #d8d8d8;
      font-weight: 700;
      font-size: 14px;
    }

    .card-amount {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      span {
        margin-top: 5px;
        font-size: 18px;
        color: #ffb31a;
      }
    }

    .card-head {
      display: flex;
      width: 100%;
      justify-content: space-between;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px dashed #ffffff;
    }

    .card-body {
      width: 100%;
    }

    .card-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      line-height: 1.5;
    }

    .card-date {
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px dashed #ffffff;

      .card-value {
        font-size: 12px;
      }
    }
  `,
  statusOrder: (key: string) => css`
    padding: 6px 10px;
    max-width: 130px;
    width: 100%;
    height: 32px;
    line-height: 1.3;
    border-radius: 5px;
    background-color: ${key};
    color: #ffffff;
    font-weight: 400;
    font-size: 13px;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  `
};
